import { LogisticError } from './logistics-error.model';

export class ShippingResponse {
    hasErrors: boolean;
    errors: LogisticError[];
}
